<template>
  <div class="section-box">
    <!-- <el-tabs v-model="seaType" type="card" class="customer-tabs-mg">
      <el-tab-pane v-for="(item, index) in titleCourse" :label="item.value" :name="item.key + ''" :key="index">
      </el-tab-pane>
    </el-tabs> -->
    <div class="customer-list">
      <!-- <div class="next-button" v-if="
          !(
            typeof actionData.customerghkh_add != 'undefined' &&
            !actionData.customerghkh_add
          )
        ">
        <el-button size="small" type="primary" icon="el-icon-plus" plain @click="checkCouseDetail(false)">新建</el-button>
        <el-button size="small" type="primary" @click="getCourseList()">查询</el-button>
        <el-button size="small" type="success" @click="resetSearch()">重置</el-button>
      </div> -->
      <el-row class="customer-row-bg">
        <el-col :span="12" style="text-align: left">
          <el-form :inline="true" label-width="80px" label-position="left">
            <el-form-item label="" size="medium">
              <!-- <el-badge :value="count0" style="margin-right: 25px" :max="99" :hidden="form.custPageType == 0 || count0 == 0"> -->
                <el-button size="mini" style="margin-right: 25px" :class="{ selected: form.custPageType == 0 }" @click="handleSearchType(0)">已发布</el-button>
              <!-- </el-badge> -->
              <!-- <el-badge :value="count1" style="margin-right: 25px" :max="99" :hidden="form.custPageType == 1 || count1 == 0"> -->
                <el-button size="mini" style="margin-right: 25px" :class="{ selected: form.custPageType == 1 }" @click="handleSearchType(1)">未发布</el-button>
              <!-- </el-badge> -->
              <!-- <el-badge :value="count2" style="margin-right: 25px" :max="99" :hidden="form.custPageType == 2 || count2 == 0"> -->
                <el-button size="mini" style="margin-right: 25px" :class="{ selected: form.custPageType == 2 }" @click="handleSearchType(2)">已删除</el-button>
              <!-- </el-badge> -->
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="12" style="text-align: right">
          <el-button size="small" type="primary" icon="el-icon-plus" plain @click="checkCouseDetail(false)">新建</el-button>
          <el-button size="small" type="primary" @click="getCourseList()">查询</el-button>
          <el-button size="small" type="success" @click="resetSearch()">重置</el-button>
        </el-col>
      </el-row>
    </div>

    <el-table :stripe="true" :data="tableData" style="width: 100%; margin-top: 20px" height="650" border
      v-loading="listLoading">
      <!-- eslint-disable  -->
      <el-table-column label="课程编号">
        <el-table-column show-overflow-tooltip>
          <template slot="header" slot-scope="scope">
            <el-input size="mini" v-model="form.courseNo" placeholder="输入关键字搜索" @change="getCourseList()" />
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.scourseNo || "--" }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="课程名称">
        <el-table-column show-overflow-tooltip>
          <template slot="header" slot-scope="scope">
            <el-input size="mini" v-model="form.courseName" placeholder="输入关键字搜索" @change="getCourseList()" />
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.scourseName || "--" }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="课程类别">
        <el-table-column show-overflow-tooltip>
          <template slot="header" slot-scope="scope">
            <el-select size="mini" placeholder="请选择" v-model="form.courseType" style="width: 100%" filterable
              @change="getCourseList()">
              <el-option value="" label="请选择"></el-option>
              <el-option v-for="(item, index) in form.courseTypeArr" :value="item.key" :label="item.value" :key="index">
              </el-option>
            </el-select>
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.scourseType || "--" }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="领域">
        <el-table-column show-overflow-tooltip>
          <template slot="header" slot-scope="scope">
            <el-select size="mini" placeholder="请选择" v-model="form.domain" style="width: 100%" filterable
              @change="getProductAndList(form.domain,'courseList')">
              <el-option value="" label="请选择"></el-option>
              <el-option v-for="(item, index) in form.domainArr" :value="item.domainid" :label="item.domainname"
                :key="index"></el-option>
            </el-select>
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.sdomain || "--" }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="产品">
        <el-table-column show-overflow-tooltip>
          <template slot="header" slot-scope="scope">
            <el-select size="mini" placeholder="请选择" v-model="form.product" style="width: 100%" filterable
              @change="getCourseList()">
              <el-option value="" label="请选择"></el-option>
              <el-option v-for="(item, index) in productSelectArr" :value="item.key" :label="item.value" :key="index">
              </el-option>
            </el-select>
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.sproduct || "--" }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="品牌">
        <el-table-column show-overflow-tooltip>
          <template slot="header" slot-scope="scope">
            <el-select size="mini" placeholder="请选择" v-model="form.brand" style="width: 100%" filterable
              @change="getCourseList()">
              <el-option value="" label="请选择"></el-option>
              <el-option v-for="(item, index) in form.brandArr" :value="item.key" :label="item.value" :key="index">
              </el-option>
            </el-select>
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.sbrand || "--" }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <!-- <el-table-column label="更新时间">
        <el-table-column show-overflow-tooltip width="250">
          <template slot="header" slot-scope="scope">
            <el-date-picker size="mini" v-model="form.updateDate" type="daterange" format="yyyy-MM-dd"
              value-format="yyyy-MM-dd" range-separator="—" start-placeholder="开始日期" end-placeholder="结束日期"
              style="width: 100%" @change="getCourseList()"></el-date-picker>
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.dupdateDate || "--" }}</span>
          </template>
        </el-table-column>
      </el-table-column> -->
      <el-table-column label="是否置顶">
        <el-table-column show-overflow-tooltip width="250">
          <template slot="header" slot-scope="scope">
            <el-select size="mini" placeholder="请选择" v-model="form.nisTop" style="width: 100%" filterable
              @change="getCourseList()">
              <el-option value="" label="请选择"></el-option>
              <el-option value="1" label="置顶"></el-option>
              <el-option value="0" label="不置顶"></el-option>
              </el-option>
            </el-select>
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.nisTop==0?'不置顶':'置顶' }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button @click="checkCouseDetail(scope.row)" type="primary" size="mini">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin: 10px; overflow: hidden">
      <div style="float: right" v-show="tableData.length">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="form.pageNum" :page-sizes="[10, 20, 50, 100, 200]" :page-size="form.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    courseList,
    dominList,
    brandList,
    courseTyeList,
    courseManageCount,
    productSelectList,
  } from "@/service/courseListApi";
  import {
    getActionData
  } from "@/utils/store";
  export default {
    components: {},
    data() {
      return {
        seaType: '1',
        actionData: JSON.parse(getActionData()), //功能按钮每个页面必须用
        titleCourse: [],
        listLoading: false,
        form: {
          pageNum: 1,
          pageSize: 10,
          courseNo: "",
          courseName: "",
          courseType: "",
          courseTypeArr: [],
          domain: "",
          domainArr: [],
          product: "",
          productArr: [],
          brand: "",
          brandArr: [],
          updateDate: [],
          custPageType: 0,

          nisTop: '',   //0不置顶 1置顶
        },
        searchData: {},
        oraginForm: {},
        total: 0, //总条数

        tableData: [],

        // 角标
        count0: 1,
        count1: 2,
        count2: 3,

        flageChangeWhList:'',
        productSelectArr:[],
      };
    },
    activated() {
      this.getListFromDetail()
    },
    beforeRouteEnter(to, from, next) {
      next((vm) => {
        vm.listbadge()
      });
    },
    created() {
      this.oraginForm = JSON.parse(JSON.stringify(this.form));
      this.tableData = [];
      this.getTitle();

      this.getCourseList();
      this.getDominList();
      this.getBrandList();
      this.getCourseTypeList();
      this.listbadge();
    },
    methods: {
      resetSearch(){
        this.form= {
          pageNum: 1,
          pageSize: 10,
          courseNo: "",
          courseName: "",
          courseType: "",
          courseTypeArr: [],
          domain: "",
          domainArr: [],
          product: "",
          productArr: [],
          brand: "",
          brandArr: [],
          updateDate: [],
          custPageType: 0,
        }
        this.getCourseList()
      },
      getProductAndList(id, type) {
                this.flageChangeWhList = type;
                this.$nextTick(() => {
                    this.getProductSelectList(id);
                });
            },
            getProductSelectList(id) {
                const _this = this;
                productSelectList(id).then((r) => {
                    if (r.Result == 1) {
                        _this.productSelectArr = r.Data || [];
                        _this.$forceUpdate();
                        if (this.flageChangeWhList == "courseList") {
                            _this.form.product = ""
                            this.getCourseList();
                            return;
                        }

                    }
                });
            },
      getListFromDetail() {
        if (this.$route.query.type) {
          this.form.custPageType = this.$route.query.type
        } else {
          this.form.custPageType = 0
        }

        this.getCourseList();
      },
      listbadge() {
        courseManageCount().then((r) => {
          if (r.Result == 1) {
            var temp = {}
            for (let i = 0; i < r.Data.length; ++i) {
              if (r.Data[i].courseStatus == 0) {
                temp.notPublish = r.Data[i].count
              }
              if (r.Data[i].courseStatus == 1) {
                temp.publish = r.Data[i].count
              }
              if (r.Data[i].courseStatus == 2) {
                temp.delCount = r.Data[i].count
              }
            }
            this.count0 = temp.publish;
            this.count1 = temp.notPublish;
            this.count2 = temp.delCount;
          }
        });
      },
      getCourseTypeList() {
        courseTyeList().then((r) => {
          if (r.Result == 1) {
            this.form.courseTypeArr = r.Data || [];
          }
        });
      },
      getBrandList() {
        brandList().then((r) => {
          if (r.Result == 1) {
            this.form.brandArr = r.Data || [];
          }
        });
      },
      getDominList() {
        dominList().then((r) => {
          if (r.Result == 1) {
            this.form.domainArr = r.Data || [];
          }
        });
      },
      async getCourseList() {
        const _this = this;
        this.listLoading = true;
        var data = {
          pageNum: _this.form.pageNum,
          pageSize: _this.form.pageSize,
          rational: false,
        };
        if (
          _this.form.updateDate instanceof Array &&
          _this.form.updateDate.length > 0
        ) {
          data.dupdateDateBegin = _this.form.updateDate[0] + " 00:00:00";
          data.dupdateDateEnd = _this.form.updateDate[1] + " 23:59:59";
        } else {
          if (data.dupdateDateBegin) delete data.dupdateDateBegin;
          if (data.dupdateDateEnd) delete data.dupdateDateEnd;
        }
        if (_this.form.custPageType == 0) {
          //已发布
          data.npublish = 1;
        }
        if (_this.form.custPageType == 1) {
          //未发布
          data.npublish = 0;
        }
        if (_this.form.custPageType == 2) {
          //已删除
          delete data.npublish;
          data.nisShow = 0;
        }

        if (_this.form.brand) data.nbrandId = _this.form.brand;
        if (_this.form.domain) data.ndomainId = _this.form.domain;
        if (_this.form.courseType) data.ncourseTypeId = _this.form.courseType;
        if (_this.form.product) data.nproductId = _this.form.product;
        if (_this.form.courseName) data.scourseName = _this.form.courseName;
        if (_this.form.courseNo) data.scourseNo = _this.form.courseNo;
        if (_this.form.courseType) data.scourseType = _this.form.courseType;
        if (_this.form.nisTop !== '') data.nisTop = _this.form.nisTop
        let res = await courseList(data);
        this.listLoading = false;
        if (res.Result != 1) {
          return this.$message.error("获取失败请联系开发人员");
        }
        this.tableData = res.Data.datas;
        this.total = res.Data.total;
      },
      checkCouseDetail(row) {
        if (row) {
          this.$router.push(`/examination/courseDetail?pkid=${row.pkid}&type=${this.form.custPageType}`);
        } else {
          this.$router.push(`/examination/courseDetail?type=3`);
        }

      },
      getTitle() {
        this.titleCourse = [{
          key: 1,
          value: "课程管理",
        }, ];
      },

      handleSearchType(type) {
        this.form.custPageType = type;
        this.form.pageNum = 1;
        this.getCourseList();
      },
      handleSizeChange(val) {
        if (this.listLoading) return;
        this.form.pageNum = 1;
        this.form.pageSize = val;
        this.getCourseList();
      },
      handleCurrentChange(val) {
        if (this.listLoading) return;
        this.form.pageNum = val;
        this.getCourseList();
      },
    },
  };
</script>
<style lang="scss">
  .customer-tabs-mg {
    .el-tabs__header {
      margin: 0 0 15px !important;
    }
  }

  .customer-list {
    position: relative;

    .next-button {
      position: absolute;
      right: 0;
      top: -56px;
    }
  }

  .customer-row-bg {
    padding: 20px 14px;
    background-color: #f9fafc;
    display: flex;
    align-items: center;

    .el-form-item {
      margin-bottom: 0 !important;
    }

    .selected {
      color: #409eff;
      border-color: #c6e2ff;
      background-color: #ecf5ff;
    }
  }

  .linkInfo {
    cursor: pointer;

    &:hover {
      color: #409eff;
    }
  }
</style>